import React from 'react';
import { useBlocker } from 'react-router-dom';

const NavigationBlocker = ({ isDirty }) => {
  // This hook intercepts navigation attempts
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isDirty && currentLocation.pathname !== nextLocation.pathname
  );

  // If the user hasn't tried to leave, or form isn't dirty, show nothing
  if (blocker.state !== "blocked") return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6 border border-gray-100">
        <div className="flex items-center gap-3 text-amber-600 mb-4">
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <h3 className="text-xl font-bold text-gray-900">Unsaved Changes</h3>
        </div>
        
        <p className="text-gray-600 text-sm mb-6 leading-relaxed">
          You have unsaved changes in your form. If you leave now, your progress will be permanently lost.
        </p>

        <div className="flex gap-3">
          <button
            onClick={() => blocker.reset()}
            className="flex-1 px-4 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold rounded-xl transition"
          >
            Stay & Edit
          </button>
          <button
            onClick={() => blocker.proceed()}
            className="flex-1 px-4 py-2.5 bg-red-600 hover:bg-red-700 text-white font-bold rounded-xl shadow-lg shadow-red-200 transition"
          >
            Discard
          </button>
        </div>
      </div>
    </div>
  );
};

export default NavigationBlocker;